import { coaching } from "../../utilities/services"
import Focus from "../Illustrations/Focus"

const Coaching = () => {
	return (
		<div id='coaching' className='app-x py-14'>
			<h3 className="text-xl text-slate-600 text-center font-bold">Our Coaching Programs includes</h3>
			<hr className="w-1/3 mx-auto my-5" />
			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4">
				<div className=" lg:max-w-[18rem]">
					{coaching.details.filter((each, i) => i <= 4).map((each, i) => (
						<div key={i} className="p-5 my-3 bg-slate-50 rounded-2xl flex space-x-4 min-h-[5.5rem]">
							<span className="text-4xl font-black text-primary">{each.count}</span>
							<p>{each.text}</p>
						</div>
					))}
				</div>
				<div className="hidden lg:flex items-center rounded-lg">
					<Focus />
				</div>
				<div className="lg:place-self-end lg:max-w-[18rem]">
					{coaching.details.filter((each, i) => i > 4).map((each, i) => (
						<div key={i} className="p-5 my-3 first:mt-0 sm:first:mt-3 bg-slate-50 rounded-2xl flex space-x-4 min-h-[5.5rem]">
							<span className="text-4xl font-black text-primary">{each.count}</span>
							<p>{each.text}</p>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default Coaching